// src/pages/writing/loose-leaves/witness.js
import React from "react";
import withBlogSEO from "../../../utils/withBlogSEO";
import FootnoteLink, {
  FootnoteProvider,
} from "../../../components/FootnoteLink";

function Witness() {
  return (
    <FootnoteProvider>
      <div className="max-w-2xl mx-auto px-4 py-8 prose prose-sm [&_a]:text-blue-600 [&_a]:no-underline [&_a:hover]:underline">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">witness</h1>
        <div className="text-gray-600">
          <p className="italic text-sm mb-4">[10/2025]</p>

            <div className="whitespace-pre-line text-base">
            <blockquote className="mb-6 border-l-4 pl-4">
              <p className="italic">
                "I have been unable to live an uncommitted or suspended life. I
                have not hesitated to declare my affiliation with an extremely
                unpopular cause. … Palestine is a thankless cause. You get
                nothing back but opprobrium, abuse, and ostracism. How many
                friends avoid the subject? How many colleagues want nothing of
                Palestine's controversy?”
              </p>
              <cite className="block mt-2 text-sm not-italic text-gray-600">
                – Edward Said, <span className="italic">Culture and Resistance: Conversations with Edward W. Said</span>, 2003
              </cite>
            </blockquote>            <p className="mb-4">
              On Monday morning, I opened my Instagram at the Coupa Cafe by Stanford’s Green
              Library. In sequence, I saw a Palestinian child{" "}
              <a
                href="https://www.instagram.com/reel/DP9eDcJkZ8M/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=="
                target="_blank"
                rel="noopener noreferrer"
              >
                holding his fainted brother
              </a>
              , toys and food boxes{" "}
              <a
                href="https://www.instagram.com/p/DPruU91EuY1/"
                target="_blank"
                rel="noopener noreferrer"
              >
                laced with explosives
              </a>
              , a man{" "}
              <a
                href="https://www.instagram.com/reel/DP1w-J7FSAX/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=="
                target="_blank"
                rel="noopener noreferrer"
              >
                whose eyes were pierced shut
              </a>{" "}
             while in detention, and Israeli soldiers{" "}
              <a
                href="https://www.instagram.com/reel/DP9p44Ljdj9/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=="
                target="_blank"
                rel="noopener noreferrer"
              >
                kidnapping two children
              </a>{" "}
              in the West Bank — and{" "}
              <a
                href="https://www.instagram.com/p/DP4CBfCDauh/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=="
                target="_blank"
                rel="noopener noreferrer"
              >
                shooting and killing
              </a>{" "}
              another. I closed this app and opened X, where I watched a settler{" "}
              <a
                href="https://x.com/swilkinsonbc/status/1979870727970144682"
                target="_blank"
                rel="noopener noreferrer"
              >
                beat a woman unconscious
              </a>{" "}
              in the West Bank,{" "}
              <a
                href="https://x.com/JustHerds/status/1979262287908151696"
                target="_blank"
                rel="noopener noreferrer"
              >
                a series of attacks
              </a>{" "}
              on Palestinian homes, an Israeli woman{" "}
              <a
                href="https://x.com/MenchOsint/status/1979123552956645620"
                target="_blank"
                rel="noopener noreferrer"
              >
                using her baby
              </a>{" "}
              to block an aid truck, a man{" "}
              <a
                href="https://x.com/QudsNen/status/1978588180644331758"
                target="_blank"
                rel="noopener noreferrer"
              >
                describing being raped in prison
              </a>
             , and then{" "}
              <a
                href="https://x.com/BigWayneConley/status/1940868218606047301"
                target="_blank"
                rel="noopener noreferrer"
              >
                a resurfaced video
              </a>{" "}
              where a different prisoner was raped.
            </p>

            <p className="mb-4">
              I put away my phone and looked back into the sunlight. In the
              seconds that followed, a group of undergraduates biked into the
              lot next to the seating area, and two women walked by with a phone
              up to their faces, on a video call with a friend. I glanced over
              to the cafe and locked eyes with the barista; we smiled at
              each other. In other words, life resumed. </p>

            <p className="mb-4">
              
              These isolated, repeated observations have separated me from my senses; I feel such a <em>loneliness</em>. I yearn for the world around me to embrace the same facts — to observe the Israeli National Security Minister Ben-Gvir
              saying they must {" "}
              <a
                href="https://x.com/clashreport/status/1980024685560758491"
                target="_blank"
                rel="noopener noreferrer"
              >
                “open the gates of hell”
              </a>{" "}
              now that the hostages are gone, to watch Israeli women {" "}
              <a
                href="https://x.com/EyeonPalestine/status/1980226918487376051"
                target="_blank"
                rel="noopener noreferrer"
              >
                steal olives
              </a>{" "}
              while Palestinian children are {" "}
              <a
                href="https://x.com/AssalRad/status/1980303198398370133"
                target="_blank"
                rel="noopener noreferrer"
              >
                blocked from attending school
              </a>{" "}
            in the West Bank — but no reality accompanies this; the sun
              keeps shining, we keep living.
            </p>

            {/* <p className="mb-4">
              If two years ago I knew that two years later, I could situate
              myself so calmly in a place who does not know this pain, I would
              shake myself. I would say, your heart is broken and you need to
              wake up, your soul is dying everyday, you must wear your
              brokenness.
            </p>

            <p className="mb-4">
              I look back at that person and cannot bring myself to reckon with
              him. Every day is full of a depth of shatteredness. I’m different
              now, I’m out of belief in humanity. And that younger version of me
              might flash with rage — bullshit, he would say, where did you go,
              come out and scream.
            </p> */}

            <hr className="my-6" />

            <p className="mb-4">
              There is one difference between this morning and most others: its
              proximity to a ceasefire,{" "}
              <a
                href="https://www.middleeasteye.net/news/netanyahu-thwarted-seven-gaza-ceasefire-deals-israeli-report-finds#:~:text=Over%20the%20course%20of%20the,referring%20to%20the%20Israeli%20leadership"
                target="_blank"
                rel="noopener noreferrer"
              >
                the eighth
              </a>{" "}
              of its kind, passed on October 11. When I saw the news, I couldn’t help but hope for
              something true.</p> 
              
            <p className="mb-4">
            Then, on the day after the ceasefire, Israeli
              forces{" "}
              <a
                href="https://english.wafa.ps/Pages/Details/163339"
                target="_blank"
                rel="noopener noreferrer"
              >
                shot and killed
              </a>{" "}
              a Palestinian in Khan Younis, {" "}
              <a
                href="https://www.dropsitenews.com/p/israel-idf-soldiers-set-fire-food-homes-sewage-treatment-plan-after-ceasefire-announced"
                target="_blank"
                rel="noopener noreferrer"
              >
                burned food, homes and a sewage treatment plant
              </a>{" "} in Gaza City, and <a href = "https://www.npr.org/2024/10/12/g-s1-27704/west-bank-palestinians-violence-israel-settlers">continued their violence</a> in the West Bank. Israeli soldiers{" "}
              <a
                href="https://x.com/aldamu_jo/status/1978660209972199715"
                target="_blank"
                rel="noopener noreferrer"
              >
                arrested two children
              </a>{" "} in East Jerusalem. An Israeli civilian used a baby in a stroller to{" "}
              <a
                href="https://www.youtube.com/shorts/pBDKqNDXL4I"
                target="_blank"
                rel="noopener noreferrer"
              >
                block an aid truck
              </a>{" "}
              leaving Israel. </p>
            
            <p className="mb-4">            
              While these new events transpired, old crimes were spotted in
              the wake. Several of the 2,000 Palestinian hostages who emerged from prison{" "}
            <a
                href="https://www.theguardian.com/world/2025/oct/20/mutilated-bodies-palestinians-held-notorious-israeli-jail-gaza-officials"
                target="_blank"
                rel="noopener noreferrer"
            >
                showed
            </a>{" "}
            <a
                href="https://x.com/SaulStaniforth/status/1978692317855805706"
                target="_blank"
                rel="noopener noreferrer"
            >
                signs
            </a>{" "}
            of{" "}
            <a
                href="https://www.youtube.com/watch?v=iLjDGSJljkQ"
                target="_blank"
                rel="noopener noreferrer"
            >
                torture
            </a>
            . A freed Palestinian {" "}
              <a
                href="https://x.com/translatingpal/status/1977781632951001258"
                target="_blank"
                rel="noopener noreferrer"
              >
                screamed
              </a>{" "}
              when he learned that his daughter had been murdered. A report emerged that 90% of the 1.1 million olive trees in the Gaza Strip had been {" "}
              <a
                href="https://www.dropsitenews.com/p/gaza-olive-groves-oil-farmers-israel-war"
                target="_blank"
                rel="noopener noreferrer"
              >
                destroyed
              </a>
             . An unidentifiable corpse <a href ="https://www.instagram.com/p/DP1xiJOiP0x/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==">was found strewn</a> on the street.</p>
              
            <p className="mb-4">
               And while I witnessed with so much admiration the attempt of the flotilla to deliver aid to Gaza, with equal sadness I watched its seizure by Israeli forces and the violence that ensued. Noa Avishag Schnall was{" "}
              <a
                href="https://www.democracynow.org/2025/10/14/headlines/journalist_abducted_by_israel_says_she_was_tortured_in_israeli_custody"
                target="_blank"
                rel="noopener noreferrer"
              >
                hung from metal shackles
              </a>{" "}
              and beaten. Greta Thunberg <a href="https://www.reuters.com/world/greta-thunberg-alleges-torture-israeli-detention-after-gaza-flotilla-arrest-2025-10-07/">was tortured</a>.{" "}
              David Adler{" "}
              <a
                href="https://www.instagram.com/reel/DPoqdc9EZwP/"
                target="_blank"
                rel="noopener noreferrer"
              >
                recounted
              </a>{" "}
              how the group was zip-tied, blindfolded, kicked, and sent to a
              detention camp, where they were abused more.</p>


            <p className="mb-4">
              How can we discuss how the future might unfold if we have not even left the past?
              I watched videos from months ago, as if the present madness were not enough.
              In Tulkarem, men were{" "}
              <a
                href="https://english.wafa.ps/Pages/Details/161262"
                target="_blank"
                rel="noopener noreferrer"
              >
                rounded up
              </a>{" "}
              and taken to concentration camps. I watch, again, the video of the{" "}
              <a
                href="https://www.cnn.com/2024/08/09/world/video/israel-sde-teiman-alleged-prisoner-abuse-footage-diamond-tsr-digvid"
                target="_blank"
                rel="noopener noreferrer"
              >
                IDF raping
              </a>{" "}
              a man. 
            </p>

            <hr className="my-6" />

            <p className="mb-4">
              The institutions around me draw the contours of possibility. Instagram{" "}
              <a
                href="https://x.com/hausofriya/status/1977886401086587277"
                target="_blank"
                rel="noopener noreferrer"
              >
                wiped the account
              </a>{" "}
              of journalist Saleh Aljafarawi after his murder by{" "}
              <a
                href="https://news.sky.com/story/videos-show-fresh-evidence-of-israeli-support-for-gaza-militia-13451682?dcmp=snt-sf-twitter"
                target="_blank"
                rel="noopener noreferrer"
              >
                 Israeli-backed gangs
              </a>
              . Google let Israel{" "}
              <a
                href="https://www.washingtonpost.com/technology/2025/10/15/israel-ads-youtube-famine-gaza/"
                target="_blank"
                rel="noopener noreferrer"
              >
                run ads
              </a>{" "}
              where they claimed they were not starving Gaza.{" "}
              {/* ; Spotify runs{""}
              <a
                href="https://www.vice.com/en/article/thursday-calls-out-spotify-over-ice-recruit-advertising/"
                target="_blank"
                rel="noopener noreferrer"
              >
                ICE recruitment ads
              </a>
              .  */}
              {/* The New York Times{" "}
              <a
                href="https://x.com/AbubakerAbedW/status/1977519252618744090"
                target="_blank"
                rel="noopener noreferrer"
              >
                lied about a war document
              </a>
              .  */}
              UN Special Rapporteur to Palestine Francesca Albanese{" "}
              <a
                href="https://lpeproject.org/blog/the-economics-of-sanctions-why-the-us-targeted-francesca-albanese/"
                target="_blank"
                rel="noopener noreferrer"
              >
                has been sanctioned
              </a>{" "}
              by the U.S. government. 36 states have <a href="https://conferenceofpresidents.org/press/conference-of-presidents-welcomes-signing-of-anti-bds-executive-order-in-new-hampshire-36-states-have-now-taken-action-against-bds/">banned support for the BDS movement</a>. Grok only{" "}
              <a
                href="https://x.com/MosabAbuToha/status/1977908816629932275"
                target="_blank"
                rel="noopener noreferrer"
              >
                validates material
              </a>{" "}
              broadcast on mainstream media; meanwhile big tech and big media collectively{" "}
              <a
                href="https://www.dropsitenews.com/p/censorship-and-military-support-how"
                target="_blank"
                rel="noopener noreferrer"
              >
                reject Palestinian stories
              </a>
              .
            </p>

            <hr className="my-6" />

            <p className="mb-4">
            Tonight, at CoHo cafe, I saw a stranger wearing a keffiyeh. I went up to him; we hugged. Later, an open mic started; this same person went on stage and performed a song about an eighteen-year-old whom Israel killed in 2022. </p>

            <p className="mb-4">
            Unfortunately, no one in the crowd was listening; everyone was working on their assignments, talking, having a drink. 
            </p>

            <hr className="my-6" />


            <p className="mb-4">  I hurried to publish this before my reality was out of date.  But while cataloguing the recent past, a new present had broken out: Israel resumed the war in full, <a href ="https://x.com/Partisan_12/status/1980960709380026403">dropping over 153 tons of bombs</a> on Gaza since October 11; 
            {/* While the IDF{" "}
              <a
                href="https://www.timesofisrael.com/in-blatant-ceasefire-violation-idf-says-terror-operatives-attacked-troops-in-rafah/"
                target="_blank"
                rel="noopener noreferrer"
              >
                claims Hamas resumed fighting
              </a>
              , others claim{" "}
              <a
                href="https://www.palestinechronicle.com/us-government-knew-hamas-was-not-behind-rafah-blast-reports/"
                target="_blank"
                rel="noopener noreferrer"
              >
                an Israeli bulldozer ran over an unexploded mine
              </a>
              .  */}
            {" "}at the same time, Israel's Shin Bet chief <a href ="https://www.i24news.tv/en/news/israel/diplomacy-defense/artc-the-new-head-of-shin-bet-imposes-the-term-judea-samaria-instead-of-west-bank">erased the term "West Bank"</a> from their official vocabulary. I just saw a conservative commentator share an image of a plane with the hammer and sickle and the name "Mamdani" on it <a href = "https://x.com/larryelder/status/1980630428328575315">flying into the World Trade Center</a>. I can't keep up.</p>

            <p className="mb-4">
              I bury myself in these facts. We are necessary contributions to the collective memory; clearly I write to witness.</p>
          </div>
        </div>
      </div>
    </FootnoteProvider>
  );
}

export default withBlogSEO(Witness, {
  title: "witness",
  type: "blog",
});
